import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import client from 'utils/clients/client';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';
import { ExternalEnrichmentProvider } from 'crono-fe-common/types/externalEnrichmentProviders';

export function useGetExternalEnrichmentProviders() {
  return useQuery<Response<ExternalEnrichmentProvider[]>, CronoError>({
    queryKey: [ENDPOINTS.enrichmentProvider.main],
    queryFn: () =>
      client({
        url: ENDPOINTS.enrichmentProvider.main,
        config: {
          method: 'get',
        },
      }),
  });
}
